import { createFileRoute } from '@tanstack/react-router'

import { requireAdminAccess } from '@/utils/router/redirects'
import { ReportsView } from '@/views/reports/ReportsView'

export const Route = createFileRoute('/reports/')({
  component: ReportsView,
  beforeLoad: async () => {
    await requireAdminAccess()
  },
})
